import Logo from '../../../components/common/Logo';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="bg-white text-[#0F172A] pt-20 pb-8 border-t border-slate-100">
      <div className="max-w-[1280px] mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-5 gap-12 mb-16">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <Logo
              className="flex items-center gap-2 mb-4"
              iconClassName="w-10 h-10"
              textClassName="text-xl font-bold tracking-tight"
            />
            <p className="text-slate-500 mb-6 leading-relaxed" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              Ihre AI-gestützte Plattform für automatisiertes Bewertungsmanagement. Mehr Vertrauen, weniger Aufwand.
            </p>

          </div>

          {/* Produkt */}
          <div>
            <h4 className="font-bold text-[#0F172A] mb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Produkt
            </h4>
            <ul className="space-y-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <li>
                <a href="#funktionen" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Funktionen
                </a>
              </li>
              <li>
                <a href="#preise" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Preise
                </a>
              </li>
              <li>
                <a href="#demo" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Demo
                </a>
              </li>
              <li>
                <a href="https://app.reputrust.ai" target="_blank" rel="noopener noreferrer" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Login
                </a>
              </li>
              <li>
                <a href="/manage-subscription" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Manage Subscription
                </a>
              </li>
            </ul>
          </div>

          {/* Ressourcen */}
          <div>
            <h4 className="font-bold text-[#0F172A] mb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Ressourcen
            </h4>
            <ul className="space-y-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <li>
                <a href="/blog" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Blog
                </a>
              </li>
              <li>
                <a href="/hilfe-center" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Hilfe-Center
                </a>
              </li>
              <li>
                <a href="/webinare" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Webinare
                </a>
              </li>
              <li>
                <a href="/case-studies" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Case Studies
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold text-[#0F172A] mb-6" style={{ fontFamily: 'Inter Tight, sans-serif' }}>
              Legal
            </h4>
            <ul className="space-y-3" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              <li>
                <a href="/impressum" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Impressum
                </a>
              </li>
              <li>
                <a href="/datenschutz" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Datenschutz
                </a>
              </li>
              <li>
                <a href="/agb" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  AGB
                </a>
              </li>
              <li>
                <a href="/cookie-richtlinie" className="text-slate-500 hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#10B981] hover:to-[#1E3A8A] transition-colors">
                  Cookie-Richtlinie
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-8 border-t border-slate-100">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4">
            <p className="text-slate-400 text-sm text-center font-medium" style={{ fontFamily: 'DM Sans, sans-serif' }}>
              © {currentYear} reputrust.ai – Alle Rechte vorbehalten
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
